import { useContext } from "react";
import { useSession } from "next-auth/client";
import theme from "@chakra-ui/theme";
import { Text, Center, Button } from "@chakra-ui/react";
import { isMobile } from "react-device-detect";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import Preview from "react-dnd-preview";
import { AiTwotoneEdit } from "react-icons/ai";
import { Container } from "components/dnd/container";
import { TweetContext } from "context/tweetContext";
import { convertToAccountTimezone } from "utils/helpers";
import { getAccount } from "utils/sessionHelper";
import { textStyle } from "theme/names";

interface Props {
  slots: any[];
  nbSlots: number;
  setSlots: any;
}

export function SchedulePanel({ slots, setSlots, nbSlots }: Props) {
  const [session] = useSession();
  const tweetContext: any = useContext(TweetContext);
  const { timezoneDiff } = convertToAccountTimezone(
    new Date(),
    getAccount(session)?.timezone
  );

  if (nbSlots <= 0) {
    return (
      <Center mt={20} flexDirection="column">
        <Text textStyle={textStyle["body.medium.light"]} m={10} fontWeight="600">
          You have not defined a queue schedule yet. Hit the button below to do
          so.
        </Text>
        <Button
          // bg="gray.600"
          variant={"primary"}
          // color="white"
          mr={0}
          leftIcon={<AiTwotoneEdit />}
          onClick={tweetContext.onOpenEditSchedule}
          // size="sm"
        >
          Edit queue planning
        </Button>
      </Center>
    );
  }

  if (isMobile) {
    return (
      <DndProvider backend={TouchBackend}>
        <Container
          //@ts-ignore
          slots={slots}
          setSlots={setSlots}
          timezoneDiff={timezoneDiff}
        />
        <Preview generator={generatePreview} />
      </DndProvider>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <Container
        //@ts-ignore
        slots={slots}
        setSlots={setSlots}
        timezoneDiff={timezoneDiff}
      />
    </DndProvider>
  );
}

function generatePreview({ item, style }) {
  style.backgroundColor = theme.colors.gray[100];
  style.borderRadius = "12px";
  style.height = "40px";
  style.width = "200px";
  style.display = "flex";
  style.padding = "10px";
  style.paddingLeft = "20px";
  style.alignItems = "center";
  style.overflow = "hidden";
  style.whiteSpace = "nowrap";
  return <div style={style}>{item?.originalIndex?.tweet?.text}</div>;
}
